const axios = require("axios");
const { successResponse, failureResponse } = require("./utils");
const api = require("./api");

module.exports = ({ baseURL, timeout = 10000 }) => {
  const client = axios.create({ baseURL });

  // Client Configuration.
  client.interceptors.response.use(successResponse, failureResponse);
  client.defaults.timeout = timeout;

  return api(client);
};



// WEBPACK FOOTER //
// ../shared/optilit-http-client/src/client.prod.js